import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import ManuallyEnteredSitesAndAppsPreview from './ManuallyEnteredSitesAndAppsPreview'
import ChannelsPreview from './ChannelsPreview'

import { dv360TargetingSelector } from '../../../../../../../modules/selectors/dv360Constants'

import { targetingTypes } from '../../../../LineItemDv360Create/fields'

const UrlsAndAppsSectionPreview = () => {
  const targeting = useSelector(dv360TargetingSelector)

  const selectedAppsTargetingOptions = useMemo(
    () => targeting.filter(option => option.type === targetingTypes.TARGETING_TYPE_APP),
    [targeting]
  )
  const selectedUrlsTargetingOptions = useMemo(
    () => targeting.filter(option => option.type === targetingTypes.TARGETING_TYPE_URL),
    [targeting]
  )
  const selectedChannelsTargetingOptions = useMemo(
    () => targeting.filter(option => option.type === targetingTypes.TARGETING_TYPE_CHANNEL),
    [targeting]
  )

  if (selectedAppsTargetingOptions.length || selectedUrlsTargetingOptions.length) {
    return <ManuallyEnteredSitesAndAppsPreview />
  } else if (selectedChannelsTargetingOptions.length) {
    return <ChannelsPreview />
  } else {
    return null
  }
}

export default UrlsAndAppsSectionPreview
